import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Google from "@mui/icons-material/Google";

interface OAuthButtonsProps {
  onGoogleSignIn: () => void;
}

export default function OAuthButtons({ onGoogleSignIn }: OAuthButtonsProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 3 }}>
      <Button
        fullWidth
        variant="outlined"
        startIcon={<Google />}
        onClick={onGoogleSignIn}
        sx={{
          py: 1.5,
        }}
      >
        Continuă cu Google
      </Button>
    </Box>
  );
}
